var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"left-bar"},[_c('div'),_c('NavBarVue'),_c('div',{staticClass:"clock-bar"},[_c('p',{staticClass:"time"},[_vm._v(_vm._s(_vm.time))]),_c('p',{staticClass:"date"},[_vm._v(_vm._s(_vm.date))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }